// 2025-08-19 11:29  mainButton完成
class DlPopX extends DlPopBaseH {
    constructor() {
        super();
        this.cleanupExpiredData();
    }

    connectedCallback() {
        // 初始化元素
        this.pop = document.querySelector('dl-pop-x');
        this.mainButton = document.querySelector('.dl-pop-x-button-main');
        this.minorButton = document.querySelector('.dl-pop-x-button-minor');
        this.popName = this.querySelector('.dl-pop-x-popup')?.dataset.popName;
        this.productHandle = this.querySelector('.dl-pop-x-product-card')?.dataset.productHandle;
        this.variantId = this.querySelector('.dl-pop-x-product-card')?.dataset.variantId;

        // 拦截原始按钮事件
        this.interceptSubmit();
        // 绑定弹窗事件
        this.bindPopupEvents();
        super.connectedCallback();
    }

    closeBtnClick() {
        super.closeBtnClick();
        DLPixelDataHelper.ProductHelper.getProductByHandle(this.productHandle, this.variantId)
            .then(variantModel => {
                DLPixelH.capture('saas_retention_pop_close', {
                    pop_name: this.popName,
                    ...variantModel
                });
            });
    }

    interceptSubmit() {
        const submitButton = document.querySelector('dl-product-addtocart-v2 .dl-product-form__submit-button-h');
        if (submitButton) {
            submitButton.addEventListener('click', (e) => {
                if (this.shouldShowPop()) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    if (this.pop) {
                        this.pop.show();
                        DLPixelDataHelper.ProductHelper.getProductByHandle(this.productHandle, this.variantId)
                            .then(variantModel => {
                                DLPixelH.capture('saas_retention_pop_show', {
                                    pop_name: this.popName,
                                    ...variantModel
                                });
                            });
                    }
                    return false;
                }
            }, true);
        }
    }

    bindPopupEvents() {
        if (this.mainButton) {
            this.mainButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.submitWithPopupVariant();
                DLPixelDataHelper.ProductHelper.getProductByHandle(this.productHandle, this.variantId)
                    .then(variantModel => {
                        DLPixelH.capture('saas_retention_pop_accept', {
                            pop_name: this.popName,
                            ...variantModel
                        });
                    });
            });
        }

        if (this.minorButton) {
            this.minorButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.submitWithMinorButton();
                DLPixelDataHelper.ProductHelper.getProductByHandle(this.productHandle, this.variantId)
                    .then(variantModel => {
                        DLPixelH.capture('saas_retention_pop_skip', {
                            pop_name: this.popName,
                            ...variantModel
                        });
                    });
            });
        }
    }

    shouldShowPop() {
        const saasAddons = document.querySelector('dl-saas-add-ons-h');
        if (!saasAddons) return false;

        const result = saasAddons.getResult();
        const checkOnlyOne = saasAddons.checkOnlyOne();

        if (result === null && !checkOnlyOne) {
            const currentProductId = this.getCurrentProductId();
            const metaObjectId = this.querySelector('.dl-pop-x-popup')?.dataset.metaObjectId;

            if (!metaObjectId) {
                return false;
            }

            const popupKey = `dl-pop-x_${metaObjectId}_product_${currentProductId}`;
            const countKey = `dl-pop-x_${metaObjectId}_count`;


            const currentProductShown = localStorage.getItem(popupKey) === 'true';
            const countData = this.getCountData(countKey);
            const totalProductsShown = countData.count;


            const canShow = !currentProductShown && totalProductsShown < 2;


            if (canShow) {
                this.markPopupAsShown();
            }

            return canShow;
        }

        return false;
    }

    submitWithMinorButton() {
        this.setButtonLoadingState(this.minorButton);

        this.addToCart()
            .then(() => this.waitForOriginalButtonReset())
            .then(() => this.closePopupAndResetButton(this.minorButton))
            .catch(error => {
                this.closePopupAndResetButton(this.minorButton);
            });
    }

    submitWithPopupVariant() {
        this.setButtonLoadingState(this.mainButton);

        this.selectSaaSAddon()
            .then(() => this.addToCart())
            .then(() => this.waitForOriginalButtonReset())
            .then(() => this.closePopupAndResetButton(this.mainButton))
            .catch(error => {
                this.closePopupAndResetButton(this.mainButton);
            });
    }

    setButtonLoadingState(button) {
        const originalSpinnerState = button.querySelector('.loading__spinner')?.classList.contains('hidden');

        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');

        const spinner = button.querySelector('.loading__spinner');
        if (spinner && originalSpinnerState !== false) {
            spinner.classList.remove('hidden');
        }

        const buttonText = button.querySelector('span, .dl-available, .dl-disabled, .dl-preorder');
        if (buttonText) {
            buttonText.style.opacity = '0';
            buttonText.style.visibility = 'hidden';
        }
    }

    waitForOriginalButtonReset() {
        return new Promise((resolve) => {
            const originalSubmitButton = document.querySelector('dl-product-addtocart-v2 .dl-product-form__submit-button-h');
            if (!originalSubmitButton) {
                resolve();
                return;
            }

            const observer = new MutationObserver(() => {
                if (this.isOriginalButtonReset(originalSubmitButton)) {
                    observer.disconnect();
                    resolve();
                }
            });

            observer.observe(originalSubmitButton, {
                attributes: true,
                attributeFilter: ['class', 'aria-disabled']
            });

            setTimeout(() => {
                observer.disconnect();
                resolve();
            }, 5000);
        });
    }

    isOriginalButtonReset(button) {
        const isNotLoading = !button.classList.contains('loading');
        const isNotDisabled = !button.hasAttribute('aria-disabled');
        const spinner = button.querySelector('.loading__spinner');
        const isSpinnerHidden = !spinner || spinner.classList.contains('hidden');

        return isNotLoading && isNotDisabled && isSpinnerHidden;
    }

    selectSaaSAddon() {
        return new Promise((resolve, reject) => {
            try {
                const popupVariantId = this.pop.querySelector('.dl-pop-x-product-card')?.dataset.variantId;
                if (!popupVariantId) {
                    reject(new Error('弹窗变体ID未找到'));
                    return;
                }

                const correspondingItem = Array.from(document.querySelectorAll('dl-saas-add-ons-h-item')).find(item => {
                    const innerDiv = item.querySelector('.dl-saas-add-ons-h-item');
                    return innerDiv && innerDiv.dataset.dlVariantId === popupVariantId;
                });

                if (!correspondingItem) {
                    reject(new Error('对应的SaaS Addon Item未找到'));
                    return;
                }

                if (typeof correspondingItem.selected === 'function') {
                    const saasAddonsContainer = correspondingItem.closest('dl-saas-add-ons-h');
                    if (saasAddonsContainer) {
                        saasAddonsContainer.dataset.cartSourceOverride =
                            this.querySelector('.dl-pop-x-popup')?.dataset.cartSource || 'popup_cart_button';
                    }

                    // 取消其他选中项
                    document.querySelectorAll('dl-saas-add-ons-h-item .dl-checkbox-h.dl-selected').forEach(checkbox => {
                        try {
                            const itemInstance = checkbox.closest('dl-saas-add-ons-h-item');
                            if (itemInstance && itemInstance !== correspondingItem && typeof itemInstance.unSelected === 'function') {
                                itemInstance.unSelected();
                            }
                        } catch (error) {
                            // 静默处理错误
                        }
                    });

                    correspondingItem.selected();
                    resolve();
                } else {
                    reject(new Error('选择方法不存在'));
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    addToCart() {
        return new Promise((resolve, reject) => {
            try {
                const originalSubmitButton = document.querySelector('dl-product-addtocart-v2 .dl-product-form__submit-button-h');
                if (originalSubmitButton) {
                    const originalShouldShowPop = this.shouldShowPop;
                    this.shouldShowPop = () => false;

                    originalSubmitButton.click();

                    setTimeout(() => {
                        this.shouldShowPop = originalShouldShowPop;
                        resolve();
                    }, 200);
                } else {
                    reject(new Error('原始提交按钮未找到'));
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    closePopupAndResetButton(button) {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');

        const spinner = button.querySelector('.loading__spinner');
        if (spinner) {
            spinner.classList.add('hidden');
            spinner.style.display = '';
            spinner.style.visibility = '';
            spinner.style.opacity = '';
        }

        const buttonText = button.querySelector('span, .dl-available, .dl-disabled, .dl-preorder');
        if (buttonText) {
            buttonText.style.opacity = '';
            buttonText.style.visibility = '';
        }

        this.pop.hide();
    }

    getCurrentProductId() {
        return window.dl_product?.id?.toString() || document.querySelector('input[name="id"]')?.value;
    }

    markPopupAsShown() {
        const currentProductId = this.getCurrentProductId();
        const metaObjectId = this.querySelector('.dl-pop-x-popup')?.dataset.metaObjectId;

        if (!currentProductId || !metaObjectId) {
            return;
        }


        const popupKey = `dl-pop-x_${metaObjectId}_product_${currentProductId}`;
        const countKey = `dl-pop-x_${metaObjectId}_count`;

        const hasShownBefore = localStorage.getItem(popupKey) === 'true';

        localStorage.setItem(popupKey, 'true');

        if (!hasShownBefore) {
            const currentCountData = this.getCountData(countKey);
            const newCountData = {
                count: currentCountData.count + 1,
                lastUpdate: Date.now()
            };

            localStorage.setItem(countKey, JSON.stringify(newCountData));
        } else {
        }

    }

    getCountData(countKey) {
        try {
            const countData = localStorage.getItem(countKey);
            if (countData) {
                return JSON.parse(countData);
            }
        } catch (error) {
        }

        return { count: 0, lastUpdate: Date.now() };
    }

    cleanupExpiredData() {
        const now = Date.now();
        const expirationTime = 15 * 24 * 60 * 60 * 1000; // 15天

        try {
            const allKeys = Object.keys(localStorage).filter(key => key.startsWith('dl-pop-x_'));
            const keysByMetaObject = {};

            allKeys.forEach(key => {
                const parts = key.split('_');
                if (parts.length >= 3) {
                    const metaObjectId = parts[2];
                    if (!keysByMetaObject[metaObjectId]) {
                        keysByMetaObject[metaObjectId] = [];
                    }
                    keysByMetaObject[metaObjectId].push(key);
                }
            });

            Object.keys(keysByMetaObject).forEach(metaObjectId => {
                const keys = keysByMetaObject[metaObjectId];
                const countKey = keys.find(key => key.endsWith('_count'));

                if (countKey) {
                    const countData = this.getCountData(countKey);
                    if (now - countData.lastUpdate > expirationTime) {
                        keys.forEach(key => {
                            localStorage.removeItem(key);
                        });
                    }
                }
            });
        } catch (error) {
        }
    }

    outSizeClick(e) {
        if (e.target === this.main) {
            this.hide();
        }

        DLPixelDataHelper.ProductHelper.getProductByHandle(this.productHandle, this.variantId)
            .then(variantModel => {
                DLPixelH.capture('saas_retention_pop_close', {
                    pop_name: this.popName,
                    ...variantModel
                });
            });
    }
}

customElements.define('dl-pop-x', DlPopX);
